const authUrl = `${process.env.VUE_APP_NEXTPORT_AUTH_BASE_URL}?client_id=${process.env.VUE_APP_NEXTPORT_CLIENT_ID}
&scope=openid%20offline_access%20profile%20email%20%20${process.env.VUE_APP_NEXTPORT_SCOPE}
&response_type=id_token%20token&redirect_uri=${encodeURI(`${process.env.VUE_APP_REDIRECT_BASE}/callback`)}&nonce=${process.env.VUE_APP_NEXTPORT_NONCE}`;

const logoutUrl = idToken => `${process.env.VUE_APP_NEXTPORT_AUTH_LOGOUT_URL}?id_token_hint=${idToken}&redirect_uri=${encodeURI(`${process.env.VUE_APP_REDIRECT_BASE}`)}`;

const checkForUnauthorized = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      window.location.href = authUrl;
    }
  }
};

export {
  authUrl,
  logoutUrl,
  checkForUnauthorized,
};
